/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BinderResponseDto } from './BinderResponseDto';
import {
    BinderResponseDtoFromJSON,
    BinderResponseDtoFromJSONTyped,
    BinderResponseDtoToJSON,
    BinderResponseDtoToJSONTyped,
} from './BinderResponseDto';

/**
 * 
 * @export
 * @interface BinderPaginationResponseDto
 */
export interface BinderPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof BinderPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<BinderResponseDto>}
     * @memberof BinderPaginationResponseDto
     */
    items: Array<BinderResponseDto>;
}

/**
 * Check if a given object implements the BinderPaginationResponseDto interface.
 */
export function instanceOfBinderPaginationResponseDto(value: object): value is BinderPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BinderPaginationResponseDtoFromJSON(json: any): BinderPaginationResponseDto {
    return BinderPaginationResponseDtoFromJSONTyped(json, false);
}

export function BinderPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(BinderResponseDtoFromJSON)),
    };
}

export function BinderPaginationResponseDtoToJSON(json: any): BinderPaginationResponseDto {
    return BinderPaginationResponseDtoToJSONTyped(json, false);
}

export function BinderPaginationResponseDtoToJSONTyped(value?: BinderPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(BinderResponseDtoToJSON)),
    };
}

